<template>
  <v-dialog v-model="$parent.isPasswordReset" persistent width="400" style="direction: rtl;">
    <v-card>
      <v-toolbar class="trHeader" style="height: 40px;">
        <v-toolbar-title class="white--text" style="text-align:center;">איפוס סיסמה</v-toolbar-title>
      </v-toolbar>
      <v-flex>
        <v-card-text>שכחת סיסמה? הכנס כתובת המייל שלך ונשלח לך את הסיסמה למייל.</v-card-text>
      </v-flex>
      <div row wrap style="padding: 20px;">
        <v-flex xs3 right>
          כתובת מייל
        </v-flex>
        <v-flex xs9>
          <input type="text" v-model="email" />
        </v-flex>
      </div>
      <v-flex>
        <span v-if="error" style="color: #c00000;">{{error}}</span>
      </v-flex>
      <v-flex actions wrap style="padding: 20px;">
        <input type="button" class="btnPopupYes" value="שלח סיסמה" @click="sendPassword" />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <input type="button" class="btnPopupNo" value="ביטול" @click="cancel" />
      </v-flex>
      <!--<v-flex actions>
        <v-flex xs5 style="padding: 20px;">
          <input type="button" class="btnPopupYes" value="שלח סיסמה" @click="sendPassword" />
        </v-flex>
        <v-flex xs5 style="padding: 20px;">
          <input type="button" class="btnPopupNo" value="ביטול" @click="cancel" />
        </v-flex>
      </v-flex>-->
    </v-card>
  </v-dialog>
</template>

<script>
  import { db, auth } from '../firebase';
  var usersRef = db.ref('Users');
  export default {
    name: 'PopupPasswordReset',
    data() {
      return {
        email: '',
        error: '',
      }
    },
    created() {
      this.$Log("Vue [PopupPasswordReset] is created ...");
    },
    ready() {
      this.$Log("Vue [PopupPasswordReset] is ready ...");
    },
    mounted() {
      this.$Log("Vue [PopupPasswordReset] is mounted ...");
    },
    updated() {
      this.$Log("Vue [PopupPasswordReset] is updated ...");
    },
    methods: {
      cancel() {
        this.email = '';
        this.$parent.isPasswordReset = false
      },
      sendPassword() {
        var vm = this;
        if (vm.email.length > 0) {
          auth.sendPasswordResetEmail(vm.email).then(function () {
            vm.$root.alert.message = 'סיסמתך נשלחה למייל.';
          }, function (error) {
            vm.$root.alert.message = 'שליחת מייל נכשלה!';
          });

          vm.$parent.isPasswordReset = false;
          vm.$root.alert.isShow = true;
        }
        else {
          vm.error = "* נא הכנס כתובת מייל!";
        }
      },
      sendPasswordOLD() {
        this.$parent.isPasswordReset = false;
        this.$root.alert.message = 'סיסמתך נשלחה למייל.';
        this.$root.alert.isShow = true;
      },
    }
  }

</script>
<style></style>



// WEBPACK FOOTER //
// PopupPasswordReset.vue?4c82c955